import api from "../../client";
import {
  UpdateCampusActivityPayload,
  UpdateCampusActivityResponseData,
} from "../../types/enum";

export const updateCampusActivityRequest = async (
  id: string | undefined,
  payload: UpdateCampusActivityPayload,
) => {
  const { data } = await api.put<UpdateCampusActivityResponseData>(
    `/campus-activity/${id}`,
    payload,
  );

  return data;
};
